import {Component, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SimpleModalService} from "../../../../services/simple-modal.service";
import {SimpleModalEnum} from "../../../../enums/enums";

@Component({
    selector: 'app-simple-modal',
    imports: [],
    templateUrl: './simple-modal.component.html',
    styleUrl: './simple-modal.component.css'
})
export class SimpleModalComponent {
  @ViewChild('confirm_simple_modal', {read : TemplateRef<any>}) confirmModal! : TemplateRef<any>;
  dismissReason: ModalDismissReasons | null = null;
  body: string = "";
  title: string = "";
  constructor(private modalService: NgbModal, private simpleModalService : SimpleModalService, private viewContainer: ViewContainerRef) {
    this.simpleModalService.getMessage$().subscribe((data) => {
      this.open(data.type, data.title, data.body, data.confirmAction, data.cancelAction);
    })
  }

  protected open(type: SimpleModalEnum, title: string = "", body: string = "", confirmAction: null|(() => void) = null, cancelAction: null|(() => void) = null) {
    let modal;
    switch (type) {
      case SimpleModalEnum.CONFIRM :
        modal = this.confirmModal;
      break;
      default:
        return;
    }
    this.title = title;
    this.body = body;
    this.modalService.open(modal, { ariaLabelledBy: 'modal-basic-title', size : "lg"}).result.then(
      (result) => {
        this.simpleModalService.closeResult = `Closed with: ${result}`;
        if(result === true && confirmAction) confirmAction();
        else if(result === false && cancelAction) cancelAction();
      },
      (reason) => {
        this.simpleModalService.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }

  getDismissReason(reason: any): string {
    switch (this.dismissReason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }
}
